import { Component } from 'react';
import { getIsPrivateBrowsing } from '$lib/privateBrowsing';

class PreBoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  componentDidMount = async () => {
    const isPrivateBrowsing = await getIsPrivateBrowsing();
    window.Aaa = window.Aaa || {};
    window.Aaa.isPrivateBrowsing = isPrivateBrowsing;

    this.setState({
      isLoading: false,
    });
  };

  render() {
    const { isLoading } = this.state;

    if (isLoading) {
      return null;
    }

    return this.props.children;
  }
}

export default PreBoot;
